var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from '../../../libs/reduxForm';
import { FormControl } from 'react-bootstrap';
import FieldValidationMessage from '../FieldValidationMessage/FieldValidationMessage';
import './FormField.css';

var FieldComponent = function FieldComponent(_ref) {
  var type = _ref.type,
      id = _ref.id,
      input = _ref.input,
      placeholder = _ref.placeholder,
      meta = _ref.meta,
      disabled = _ref.disabled;
  return React.createElement(Fragment, null, React.createElement(FormControl, _extends({
    type: type,
    id: id,
    placeholder: placeholder,
    disabled: disabled
  }, input)), React.createElement(FieldValidationMessage, meta));
};

var TextField = function TextField(_ref2) {
  var type = _ref2.type,
      name = _ref2.name,
      placeholder = _ref2.placeholder,
      label = _ref2.label,
      validate = _ref2.validate,
      disabled = _ref2.disabled,
      _ref2$showOptionalLab = _ref2.showOptionalLabel,
      showOptionalLabel = _ref2$showOptionalLab === void 0 ? false : _ref2$showOptionalLab;
  return React.createElement('div', {
    className: 'form-group TextField'
  }, React.createElement('label', {
    className: 'control-label control-label--fullWidth',
    htmlFor: "text-field-".concat(name)
  }, label, showOptionalLabel && React.createElement('span', {
    className: 'label-optional'
  }, '(optional)')), React.createElement(Field, {
    type: type,
    id: "text-field-".concat(name),
    disabled: disabled,
    name: name,
    placeholder: placeholder,
    component: FieldComponent,
    validate: validate
  }));
};

TextField.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string
};
export default TextField;